import React, { useState, useEffect } from 'react';
import { LanguageContext } from '@/contexts/LanguageContext';
import pt from '@/locales/pt.json';
import en from '@/locales/en.json';
import es from '@/locales/es.json';

const translationsMap = { pt, en, es };

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState('pt');

  useEffect(() => {
    // Determine initial language from path or localStorage
    const pathLang = window.location.pathname.split('/')[1];
    if (['pt', 'en', 'es'].includes(pathLang)) {
      setLanguageState(pathLang);
      localStorage.setItem('provatio_language', pathLang);
    } else {
      const savedLang = localStorage.getItem('provatio_language');
      const browserLang = navigator.language.split('-')[0];
      const defaultLang = savedLang || (['pt', 'en', 'es'].includes(browserLang) ? browserLang : 'pt');
      setLanguageState(defaultLang);
      localStorage.setItem('provatio_language', defaultLang);
    }
  }, []);

  const setLanguage = (lang) => {
    setLanguageState(lang);
    localStorage.setItem('provatio_language', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translations: translationsMap[language] || pt }}>
      {children}
    </LanguageContext.Provider>
  );
};